// ------------------------------------
// Constants
// ------------------------------------
export const LIST_VIEW_SET_CURRENT_PAGE = 'leagueMembers.LIST_VIEW_SET_CURRENT_PAGE';
export const LIST_VIEW_SET_TOTAL_PAGES = 'leagueMembers.LIST_VIEW_SET_TOTAL_PAGES';
export const LIST_VIEW_PROGRAM_MEMBER_IDS_BY_PAGE = 'leagueMembers.LIST_VIEW_PROGRAM_MEMBER_IDS_BY_PAGE';
export const CLEAR_LIST_VIEW_PROGRAM_MEMBER_IDS_BY_PAGE = 'leagueMembers.CLEAR_LIST_VIEW_PROGRAM_MEMBER_IDS_BY_PAGE';
export const LIST_VIEW_SEARCH_FILTERS = 'leagueMembers.LIST_VIEW_SEARCH_FILTERS';
export const LIST_VIEW_SET_TOTAL_PROGRAM_MEMBER_COUNT = 'leagueMembers.LIST_VIEW_SET_TOTAL_PROGRAM_MEMBER_COUNT';
